(function() {
  'use strict';

  angular
    .module('blocks.setup', []);
})();
